export const CARD_GAP = 12;
export const FOCUS_RING_GUTTER = 2;
